import { colors } from '@dexma/ui-components';
import { useBranding } from 'adapter/in/common/context/static/Branding';
import { useProfile } from 'adapter/in/common/context/static/Profile';
import { useNavigation } from 'adapter/in/common/hooks/useNavigation';
import { reportsPath } from 'adapter/in/common/routes';
import GeneratePDFOverlayBody from 'adapter/in/reports/components/GeneratePDFOverlayBody/GeneratePDFOverlayBody';
import GeneratePDFOverlayHeader from 'adapter/in/reports/components/GeneratePDFOverlayHeader/GeneratePDFOverlayHeader';
import { getFormattedPeriod } from 'adapter/in/reports/contexts/GeneratePDFContext';
import i18n from 'asset/translation';

import { ReportInstance } from 'domain/entity/reportInstance';
import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

type GeneratePDFOverlayContainerProps = {
    reportInstance: ReportInstance;
    onDownload: () => void;
    progress: number;
    elements: number;
    loadedElements: number;
    onReadyToGeneratePDF: (status: boolean) => void;
};
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const StyledOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    background-color: ${colors.gray100};
    animation: ${fadeIn} 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
`;

const GeneratePDFOverlayContainer = (props: GeneratePDFOverlayContainerProps) => {
    const { reportInstance, onDownload, progress, elements, loadedElements, onReadyToGeneratePDF } = props;
    const { branding } = useBranding();
    const { profile } = useProfile();
    const { navigationPush } = useNavigation();

    useEffect(() => {
        onReadyToGeneratePDF(true);

        return () => onReadyToGeneratePDF(false);
    }, []);

    const period = getFormattedPeriod(reportInstance, profile.dateFormat);

    const getCompletion = () => {
        if (progress <= 50) {
            return `${loadedElements}/${elements} ${i18n.t('reports.progressOverlay.analysis')}`;
        }
        return i18n.t('reports.progressOverlay.rendering');
    };

    return (
        <StyledOverlay role='alert' aria-live='assertive' aria-busy='true'>
            <GeneratePDFOverlayHeader
                reportInstanceId={reportInstance.id}
                onCancel={() => {
                    navigationPush('', reportsPath);
                }}
            />
            <GeneratePDFOverlayBody
                progress={progress}
                color={branding.primaryColor}
                name={reportInstance.name}
                location={reportInstance.context.locationName}
                language={reportInstance.context.languageName}
                period={period}
                completion={getCompletion()}
                onDownload={onDownload}
            />
        </StyledOverlay>
    );
};

export default GeneratePDFOverlayContainer;
